import React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 90%;
  margin: 5% 10% 10% 10%;
  display: flex;
  justify-content: space-between;
`;

const PapersHeader = styled.h1`
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
`

const PapersWrapper = styled.div`
  width: 70%;
`;

const PapersType = styled.div`
  position: relative;
`;

const PapersTypeHeader = styled.h2`
  padding-bottom: 10px;
`;

const PapersSubtypeHeader = styled.h3`
  padding-bottom: 10px;
`;

const Paper = styled.div`
  font-size: 12pt;
  padding-bottom: 20px;
  padding-left: 60px;
  &:before {
    /* content: "2024"; */
    content: ${(props) => (props.year ? `"${props.year}"` : `""`)};
    position: absolute;
    left: 0px;
    /* font-weight: bold; */
    display: inline-block;
    color: black;
  }
`;

const PaperCitation = styled.div`
  padding-left: 36px;
  text-indent: -36px;
`;

const UnderlineAuthor = styled.span`
  font-weight: bold;
  text-decoration: underline;
`;

const PrimaryPublication = styled.span`
  font-style: italic;
`;

const PaperTags = styled.div`
  margin: 0px 36px;
  font-size: 9pt;
  display: flex;
  flex-wrap: wrap;
`;

const PaperTag = styled.div`
  background-color: slategray;
  color: white;
  border-radius: 20px;
  margin: 5px 5px;
  padding: 5px 10px;
  font-weight: bold;
  white-space: nowrap;
`;

const PapersTypeBreak = styled.hr`
  margin: 0px 0px 20px 0px;
  color: lightgray;
`;

const Link = styled.a`
  color: blue;
  text-decroation: underline;
`;

const Papers = () => {
  return (
    <Container>
      <PapersWrapper>
        <PapersHeader>Publications</PapersHeader>
        <PapersType>
          <PapersTypeHeader>Book chapters</PapersTypeHeader>
          <PapersSubtypeHeader>Linguistics</PapersSubtypeHeader>
          <Paper year={"curr."}>
            <PaperCitation>
              Bradley McDonnell,{" "}
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, & Yanti. in
              revision. The languages of Sumatra and the Barrier Islands. In
              Bill Palmer & Ellen Smith-Dennis (eds.),{" "}
              <PrimaryPublication>
                The languages and linguistics of Island Southeast Asia and the
                Pacific
              </PrimaryPublication>
              . Berlin: De Gruyter Mouton.
            </PaperCitation>
          </Paper>
          <Paper year={"2025"}>
            <PaperCitation>
              Bradley McDonnell &{" "}
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2025. Choosing
              fillers in Besemah. In Brigitte Pakendorf & Françoise Rose (eds.),{" "}
              <PrimaryPublication>
                Fillers: Hesitatives and placeholders
              </PrimaryPublication>{" "}
              (Research on Comparative Grammar 5), 169–210. Berlin: Language
              Science Press. (doi:
              <Link href={"https://doi.org/10.5281/zenodo.15632051"}>
                10.5281/zenodo.15632051
              </Link>
              )
            </PaperCitation>
            {/* <PaperTags>
              <PaperTag>Fillers</PaperTag>
              <PaperTag>Austronesian (Sumatra)</PaperTag>
            </PaperTags> */}
          </Paper>
          <Paper>
            <PaperCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor> & Bradley
              McDonnell. 2025. Fillers in the gray: Indeterminacy in their use
              in everyday conversation. In Brigitte Pakendorf & Françoise Rose
              (eds.),{" "}
              <PrimaryPublication>
                Fillers: Hesitatives and placeholders
              </PrimaryPublication>{" "}
              (Research on Comparative Grammar 5), 211–250. Berlin: Language
              Science Press. (doi:
              <Link href={"https://doi.org/10.5281/zenodo.15632051"}>
                10.5281/zenodo.15632051
              </Link>
              )
            </PaperCitation>
            {/* <PaperTags>
              <PaperTag>Fillers</PaperTag>
              <PaperTag>Austronesian (Sumatra)</PaperTag>
            </PaperTags> */}
          </Paper>
        </PapersType>
        <PapersTypeBreak />
        <PapersType>
          <PapersTypeHeader>Articles</PapersTypeHeader>
          <PapersSubtypeHeader>Linguistics</PapersSubtypeHeader>
          <Paper year={"2024"}>
            <PaperCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor> & Bradley
              McDonnell. 2024. Sumatran.{" "}
              <PrimaryPublication>Oceanic Linguistics</PrimaryPublication>{" "}
              63(1), 112–174. (doi:
              <Link href={"https://doi.org/10.1353/ol.2024.a928205"}>
                10.1353/ol.2024.a928205
              </Link>
              )
            </PaperCitation>
            {/* <PaperTags>
              <PaperTag>Historical Linguistics</PaperTag>
              <PaperTag>Austronesian (Sumatra)</PaperTag>
            </PaperTags> */}
          </Paper>
          <PapersSubtypeHeader>
            Mathematics / Computer science
          </PapersSubtypeHeader>
          <Paper year={"2020"}>
            <PaperCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, Kasifa
              Namyalo, & Dinesh G. Sarvate. 2020. GDD (<i>n</i>₁+<i>n</i>
              ₂,3;λ₁,λ₂) for <i>n</i>₁=2 and <i>n</i>₂=5.{" "}
              <PrimaryPublication>Ars Combinatoria</PrimaryPublication> 149,
              129–135; <PrimaryPublication>Ars Combinatoria</PrimaryPublication>{" "}
              150, 281–293.
            </PaperCitation>
          </Paper>
          <Paper year={"2019"}>
            <PaperCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2019. GDD(
              <i>n</i>,2,4;λ₁,λ₂) with equal number of blocks of three
              configurations.{" "}
              <PrimaryPublication>
                Journal of Combinatorial Mathematics and Combinatorial Computing
              </PrimaryPublication>{" "}
              110, 9–18. (
              <Link
                href={
                  "https://combinatorialpress.com/jcmcc-articles/volume-110/gddn-2-4-lambda_1-lambda_2-with-equal-number-of-blocks-of-three/"
                }
                target="_blank"
              >
                https://combinatorialpress.com/jcmcc-articles/volume-110/gddn-2-4-lambda_1-lambda_2-with-equal-number-of-blocks-of-three/
              </Link>
              )
            </PaperCitation>
          </Paper>
          <Paper>
            <PaperCitation>
              Xenia Mountrouidou,{" "}
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, & Luis
              Mejía-Ricart. 2019. Not just another internet of things taxonomy:
              A method for validation of taxonomies.{" "}
              <PrimaryPublication>Internet of Things</PrimaryPublication> 6.{" "}
              (doi:
              <Link
                href={"https://doi.org/10.1016/j.iot.2019.03.003"}
                target="_blank"
              >
                10.1016/j.iot.2019.03.003
              </Link>
              )
            </PaperCitation>
          </Paper>
          <Paper year={"2017"}>
            <PaperCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, Kasifa
              Namyalo, & Dinesh G. Sarvate. 2017. GDD(<i>n</i>₁+<i>n</i>
              ₂,3;λ₁,λ₂) with equal number of blocks of two configurations.{" "}
              <PrimaryPublication>
                Journal of Combinatorial Mathematics and Combinatorial Computing
              </PrimaryPublication>{" "}
              102, 19–44. (
              <Link
                href={
                  "https://combinatorialpress.com/jcmcc-articles/volume-102/gddn_1-n_2-3-lambda_1-lambad_2-with-equal-number-of-blocks-of-two-configurations/"
                }
                target="_blank"
              >
                https://combinatorialpress.com/jcmcc-articles/volume-102/gddn_1-n_2-3-lambda_1-lambad_2-with-equal-number-of-blocks-of-two-configurations/
              </Link>
              )
            </PaperCitation>
          </Paper>
        </PapersType>
        <PapersTypeBreak />
        <PapersType>
          <PapersTypeHeader>Conference proceedings</PapersTypeHeader>
          <PapersSubtypeHeader>Linguistics</PapersSubtypeHeader>
          <Paper year={"2025"}>
            <PaperCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2025. Building
              a comparative lexical database for the Sumatran languages. In
              Alessa Farinella & Jed Sam Pizarro-Guevarra (eds.),{" "}
              <PrimaryPublication>
                Proceedings of the 31st Annual Meeting of the Austronesian
                Formal Linguistics Association
              </PrimaryPublication>
              , 123–134. Amherst, MA: University of Massachusetts, Amherst. (<Link href={"https://ojs.lib.uwo.ca/index.php/afla"}>https://ojs.lib.uwo.ca/index.php/afla</Link>)
            </PaperCitation>
          </Paper>
          <Paper>
            <PaperCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, Bradley
              McDonnell, Johan Safri, & Wawan Sahrozi. 2025. Connecting
              automated speech recognition to transcription practices. In Jordan
              Lachler, Godfred Agyapong, Antti Arppe, Sarah Moeller, Aditi
              Chaudhary, Shruti Rijhwani, & Daisy Rosenblum (eds.),{" "}
              <PrimaryPublication>
                Proceedings of the Eight Workshop on the Use of Computational
                Methods in the Study of Endangered Languages
              </PrimaryPublication>
              , 128–132. Honolulu, HI: Association for Computational
              Linguistics. (
              <Link href={"https://aclanthology.org/2025.computel-main/"}>
                https://aclanthology.org/2025.computel-main/
              </Link>
              )
            </PaperCitation>
            {/* <PaperTags>
              <PaperTag>Fillers</PaperTag>
              <PaperTag>Austronesian (Sumatra)</PaperTag>
            </PaperTags> */}
          </Paper>{" "}
          <Paper year={"2023"}>
            <PaperCitation>
              Nay San, Martijn Bartelds,{" "}
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, Ella del
              Falco, Hendi Feriza, Johan Safri, Wawan Sahrozi, Ben Foley,
              Bradley McDonnell, & Dan Jurafsky. 2023. Leveraging supplementary
              text data to kick-start automatic speech recognition system
              development with limited transcriptions. In Harrigan, Atticus,
              Aditi Chaudhary, Shruti Rijhwani, Sarah Moeller, Antti Arppe,
              Alexis Palmer, Ryan Henke, & Daisy Rosenblum (eds.),{" "}
              <PrimaryPublication>
                Proceedings of the Sixth Workshop on the Use of Computational
                Methods in the Study of Endangered Languages
              </PrimaryPublication>
              , 1–6. Remote: Association for Computational Linguistics. (arXiv:
              <Link href={"https://arxiv.org/abs/2302.04975"}>
                2302.04975v1
              </Link>
              )
            </PaperCitation>
            {/* <PaperTags>
              <PaperTag>Computational Linguistics</PaperTag>
              <PaperTag>Automated Speech Transcription</PaperTag>
            </PaperTags> */}
          </Paper>
          <PapersSubtypeHeader>
            Mathematics / Computer science
          </PapersSubtypeHeader>
          <Paper year={"2018"}>
            <PaperCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2018.
              Modelling correct operation of webcams for security purposes. In{" "}
              <PrimaryPublication>
                Proceedings of the 49ᵗʰ ACM Technical Symposium on Computer
                Science Education (SIGCSE2018)
              </PrimaryPublication>
              . (doi:
              <Link
                href={"https://doi.org/10.1145/3159450.3162339"}
                target="_blank"
              >
                10.1145/3159450.3162339
              </Link>
              ,{" "}
              <Link
                href={
                  "./files/Billings_2018_ModellingCorrectOperationOfWebcamsForSecurityPurposes.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PaperCitation>
          </Paper>
        </PapersType>
        <PapersTypeBreak />
        <PapersType>
          <PapersTypeHeader>Other</PapersTypeHeader>
          <PapersSubtypeHeader>Linguistics</PapersSubtypeHeader>
          <Paper year={2020}>
            <PaperCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2020. Review
              of <PrimaryPublication>Bola Grammar Sketch</PrimaryPublication>{" "}
              (Data Papers on Papua New Guinea Languages 63) by Brent Wiebe &
              René van den Berg.{" "}
              <PrimaryPublication>
                Languages & Linguistics in Melanesia
              </PrimaryPublication>
              38.
            </PaperCitation>
          </Paper>
          <Paper>
            <PaperCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2020.{" "}
              <PrimaryPublication>
                Modality and what should would be acceptable: Syntactic
                promiscuity in Spanish and English double modal constructions
              </PrimaryPublication>
              . Charleston, SC: College of Charleston. (Bachelor's thesis.)
            </PaperCitation>
          </Paper>
        </PapersType>
      </PapersWrapper>
    </Container>
  );
};

export default Papers;
